
import { Union, Record } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type, class_type, anonRecord_type, record_type, list_type, option_type, string_type } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ApiReceiver_$reflection, Requests_ApiReceiverFormDto_$reflection } from "../../../../Shared/User.js";
import { ClientApiResponse$1_$reflection, AccountSettings_$reflection, FormState_$reflection, RequestedValue$1_$reflection } from "../../../../Shared/Shared.js";
import { BusinessUnitOverviewDto_$reflection } from "../../../../Shared/BusinessUnit.js";

export class State extends Record {
    constructor(ApiReceiverId, Form, FormState, BusinessUnits, AccountSettings) {
        super();
        this.ApiReceiverId = ApiReceiverId;
        this.Form = Form;
        this.FormState = FormState;
        this.BusinessUnits = BusinessUnits;
        this.AccountSettings = AccountSettings;
    }
}

export function State_$reflection() {
    return record_type("Settings.UserManagement.ApiReceiver.Types.State", [], State, () => [["ApiReceiverId", option_type(string_type)], ["Form", RequestedValue$1_$reflection(Requests_ApiReceiverFormDto_$reflection())], ["FormState", FormState_$reflection()], ["BusinessUnits", RequestedValue$1_$reflection(list_type(BusinessUnitOverviewDto_$reflection()))], ["AccountSettings", RequestedValue$1_$reflection(AccountSettings_$reflection())]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetName", "SetEmail", "SetBusinessUnit", "CreateApiReceiver", "UpdateApiReceiver", "ApiReceiverFetched", "ApiReceiverSaved", "AccountSettingsFetched", "BusinessUnitsFetched", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Settings.UserManagement.ApiReceiver.Types.Msg", [], Msg, () => [[["Item", string_type]], [["Item", string_type]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", BusinessUnitOverviewDto_$reflection()]))]], [], [], [["Item", ApiReceiver_$reflection()]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", AccountSettings_$reflection()]], [["Item", list_type(BusinessUnitOverviewDto_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

